import { render } from "./portfolio-tile.vue?vue&type=template&id=afefcc9c"
import script from "./portfolio-tile.vue?vue&type=script&lang=js"
export * from "./portfolio-tile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__